import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { influencerInterested } from '../../store/actions/dealActions';
import { retireCampaign } from '../../store/actions/campaignActions';
import {
  getProposedDealsByCampaignId,
  getActiveandOrFutherByCampaignId
} from '../../store/selectors/deals';

const styles = theme => ({
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '40px'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3
    }
  },
  pageTitle: {
    marginTop: '20px',
    marginBottom: '20px',
    cursor: 'pointer'
  },
  backButton: {
    marginBottom: '30px',
    color: 'black'
  },
  backArrow: {
    marginBottom: '4px',
    marginRight: '10px'
  },
  image: {
    maxWidth: '100px',
    maxHeight: '100px',
    borderRadius: '100px',
    marginRight: '20px'
  },
  interestedButton: {
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      marginTop: '30px'
    }
  },
  interestedSentButton: {
    color: '#22c26e',
    [theme.breakpoints.down('sm')]: {
      marginTop: '30px'
    }
  },
  retireButton: {
    color: '#ce1212',
    [theme.breakpoints.down('sm')]: {
      marginTop: '30px'
    }
  },
  paragraph: {
    marginTop: '30px'
  },
  propertyItem: {
    width: '100px',
    display: 'inline-block',
    marginTop: '50px'
  },
  // paperSection: {
  //   marginTop: '50px'
  // },
  brandStoryContainer: {
    marginTop: '30px'
  },
  goalsContainer: {
    marginTop: '30px'
  },
  productPhoto: {
    maxHeight: '250px',
    maxWidth: '250px',
    borderRadius: '200px'
  },
  productContainer: {
    marginTop: '20px',
    textAlign: 'center',
    color: 'black!important',
    textDecoration: 'underline!important'
  },
  activeText: {
    color: '#22c26e'
  },
  retiredText: {
    color: '#ce1212'
  },
  paymentButton: {
    color: 'white',
    marginTop: '20px'
  },
  deleteButtonsContainer: {
    marginTop: '50px'
  },
  deleteCancelButtons: {
    width: '85px'
  },
  deleteAcceptButtons: {
    width: '85px',
    float: 'right'
  },
  campaignTab: {
    outline: 'none !important'
  },
  analyticsContainer: {
    display: 'inline-flex',
    float: 'right'
  },
  analyticsButton: {
    float: 'right',
    border: '1px solid #22c26e',
    color: '#22c26e'
  }
});

const mapStateToProps = (state, ownProps) => {
  const campId = ownProps.match.params.id;
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth,
    allProposals: getProposedDealsByCampaignId(campId)(state),
    allActiveandOrFutherDeals: getActiveandOrFutherByCampaignId(campId)(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    interestedClickHandler: (influencerId, companyId, campaignId, hist) =>
      dispatch(influencerInterested(influencerId, companyId, campaignId, hist)),
    retireCampaignClickHandler: campaignId =>
      dispatch(retireCampaign(campaignId, ownProps))
  };
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/Campaign.enhancer.js